import React from "react";
import "../css/postLayout.css";
import "../css/postList.css";
import truncateWords from "../../../../format/truncateWords";
import { Link } from "react-router-dom";

const PostList = ({ data }) => {
  const getTopicSlug = post => {
    const { topics } = post;
    return topics[0]?.slug;
  };

  return (
    <div className="bg-white shadow-lg mb-3 list-of-posts row">
      {data.map((post, index) => (
        <div key={index} className=" col-12 col-md-6  item">
          <div className=" p-md-2">
            <div className="image-wrapper">
              <Link
                to={`/bai-viet/${getTopicSlug(post)}/${post.slug}`}
                title={post.title}
              >
                <img
                  src={post.thumbnail}
                  alt={post.title}
                  className="img-post"
                />
              </Link>
            </div>
            <div className=" pl-4">
              <h3 className="mt-2 mb-1">
                <Link
                  to={`/bai-viet/${getTopicSlug(post)}/${post.slug}`}
                  title={post.title}
                >
                  {post.title}
                </Link>
              </h3>{" "}
              <p className="description">
                <Link
                  style={{ color: "var(--black)" }}
                  to={`/${getTopicSlug(post)}/${post.slug}`}
                  title={post.title}
                >
                  {truncateWords(post.short_description, 20)}
                </Link>
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostList;
